import React, { createElement } from "react";
import { Disclosure } from "@headlessui/react";
import { h1, h4, p } from "@components/ui/typography/typography.module.css";
import Section from "@layouts/section";
import DualColumn from "@components/ui/dual-column";
import TextLabel from "@components/ui/text-label";
import { cn } from "@/utils";
import Arrow from "../../images/services/arrow.svg";
import ReactMarkdown from "react-markdown";
import ScheduleButton from "../ui/schedule-button";

type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
interface Faq {
  question: string;
  answer: {
    data: {
      answer: string;
    };
  };
  faq_tags: {
    tag: string;
  }[];
}

export interface FaqQueryResultTypes {
  allStrapiFaq: {
    nodes: Faq[];
  };
}

interface FaqsProps {
  data: Faq[];
  className?: string;
  title?: string;
  label?: string;
  subTitle?: string;
  btnText?: string;
  heading?: HeadingType;
}

const Faqs: React.FC<FaqsProps> = ({
  className,
  data,
  label = "FAQs",
  title = "Clear answers to your complex questions",
  subTitle = "",
  btnText = "",
  heading = "h2"
}) => {
  const result = data || [];
  if (result.length === 0) return null;
  const Heading = createElement(heading, { className: `${h1}` }, title);
  return (
    <Section className={className}>
      <DualColumn
        firstColumn={
          <>
            <TextLabel>{label}</TextLabel>
            <div className={`${h1} mt-6`}>{Heading}</div>
            {subTitle && btnText && (
              <div className="mt-20">
                <p className={p}>{subTitle}</p>
                <ScheduleButton className="mt-5">{btnText}</ScheduleButton>
              </div>
            )}
          </>
        }
        firstColumnClassName="flex-col"
        lastColumn={
          <div className={`w-full ${cn(className)}`}>
            {result.map((f, i) => (
              <Disclosure key={i} as="div" className="py-6 first:border-t border-b border-dark">
                {({ open }) => (
                  <>
                    <Disclosure.Button className="w-full inline-block text-left">
                      <div className="flex justify-between items-center w-full gap-2">
                        <h4 className={`${h4} flex grow`}>{f.question}</h4>
                        <div className="flex grow-0 shrink-0 w-12 h-12">
                          <img
                            src={Arrow}
                            alt="Down arrow icon"
                            className={`will-change-transform transition-transform ${
                              open ? "-rotate-90" : "rotate-90"
                            }`}
                          />
                        </div>
                      </div>
                    </Disclosure.Button>
                    <Disclosure.Panel className="mt-6">
                      <ReactMarkdown className="markdown-content">
                        {f.answer.data.answer}
                      </ReactMarkdown>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </div>
        }
        lastColumnClassName="mt-16 md:mt-14"
      />
    </Section>
  );
};

export default Faqs;
